import angular, {IFormController, IModule, IPromise} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {MeldingTilBruker} from "../../../../../felles/tjenester/MeldingTilBruker";
import {regNavn} from "../../../../../felles/tjenester/tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {UuidGenerator} from "../../../../../felles/tjenester/UuidGenerator";
import {AvstemningRessurs} from "../../../../../felles/tjenester/ressurser/AvstemningRessurs";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {ModelloppdateringTjeneste} from "web/tjenester/ModelloppdateringTjeneste";

const css = require('./redigerAvstemningDialog.scss');


export class RedigerAvstemningDialog {
    static regNavn = "wm.møte.modale.redigeravstemningDialog.RedigeravstemningDialog";

    static registrerDialog(angular: IModule) {
        angular
            .service(RedigerAvstemningDialog.regNavn, RedigerAvstemningDialog.forInjisering())
            .controller(RedigerAvstemningKontroller.regNavn, RedigerAvstemningKontroller.forInjisering())
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            RedigerAvstemningDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    private dialogKonfigurasjon = {
        template: require('./redigerAvstemningDialog.html'),
        controller: RedigerAvstemningKontroller.regNavn,
        controllerAs: '$ctrl',
        bindToController: true
    };

    visRedigerAvstemningDialog(avstemning: l.AvstemningMedResultatModell):IPromise<l.AvstemningMedResultatModell> {
        return this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {avstemning: avstemning}}));
    }

    visNyAvstemningDialog(sak: l.AgendaelementModell):IPromise<l.AvstemningMedResultatModell> {
        return this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {sak: sak}}));
    }
}

export class RedigerAvstemningKontroller implements MdDialogController {

    static regNavn = "wm.møte.modale.redigeravstemningDialog.RedigerAvstemningKontroller";

    static forInjisering() {
        return [
            AvstemningRessurs.regNavn,
            UuidGenerator.regNavn,
            regNavn.md.$mdDialog,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            ModelloppdateringTjeneste.regNavn,
            RedigerAvstemningKontroller
        ]
    }

    constructor(private avstemningRessurs:AvstemningRessurs,
                private uuidGenerator: UuidGenerator,
                private $mdDialog: angular.material.IDialogService,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog,
                private modelloppdatering: ModelloppdateringTjeneste) {
    }

    $onInit(){
        this.initData();
    }

    avstemning: l.AvstemningMedResultatModell; //satt via locals.avstemning i dialogKonfigurasjon, satt ved rediger
    sak: l.AgendaelementModell; //satt via locals.sak i dialogKonfigurasjon, satt ved opprett ny

    modus: string;
    lagrer = false;
    modell : AvstemningskjemaModell;

    submitKnappDisabled(skjema:IFormController){
        if (skjema.$invalid || this.lagrer) return true;
        return !this.modell.harMinstEttIkkeTomtAlternativ();
    }

    lagre(skjema:IFormController) {
        if (!skjema.$valid) return;
        this.lagrer = true;
        (this.modus == "rediger" ?
            this.avstemningRessurs.oppdater(this.modell.somOppdaterAvstemningSpesifikasjon()) :
            this.avstemningRessurs.opprett(this.modell.somOpprettAvstemningSpesifikasjon())).$promise
            .then(avstemning => {
                this.$mdDialog.hide(avstemning);
                if (this.modus == "rediger") {
                    this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Avstemning har blitt oppdatert'));
                    this.modelloppdatering.broadcastLokalOppdatertAvstemning(avstemning);
                } else {
                    this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Avstemning registrert'));
                    this.modelloppdatering.broadcastLokalNyAvstemning(avstemning);
                }
            })
            .finally(() => this.lagrer = false);
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    //hjelpemetoder

    private initData(){
        if (this.sak) {
            this.modell = AvstemningskjemaModell.modellForNyAvstemning(this.sak, this.uuidGenerator);
            this.modus = "ny";
            return;
        }

        this.modus = "rediger";
        this.modell = AvstemningskjemaModell.modellForRedigerAvstemning(this.avstemning);
        //sørg for å få ferske data
        this.avstemningRessurs.hent(this.avstemning.id).$promise
            .then(avstemning => this.modell = AvstemningskjemaModell.modellForRedigerAvstemning(avstemning));
    }
}

class AvstemningskjemaModell {
    avstemningId:string;
    sakId:string;
    eiendeGruppeId:string;

    spesifikasjon: {
        tittel: string;
        beskrivelse: string;
        alternativer: l.AvstemningsalternativSpesifikasjon[];
    };

    static modellForNyAvstemning(sak:l.AgendaelementModell, uuidGenerator: UuidGenerator):AvstemningskjemaModell{
        const modell = new AvstemningskjemaModell();
        modell.avstemningId = uuidGenerator.generer();
        modell.sakId = sak.id;
        modell.eiendeGruppeId = sak.eiendeGruppeId;
        modell.spesifikasjon = {
            tittel: '',
            beskrivelse: '',
            alternativer: []
        };
        modell.leggTilNyttAlternativ(); //viser alltid en tom rad til slutt
        return modell;
    }

    static modellForRedigerAvstemning(avstemning: l.AvstemningMedResultatModell):AvstemningskjemaModell{
        const modell = new AvstemningskjemaModell();
        modell.avstemningId = avstemning.id;
        modell.sakId = avstemning.sakId;
        modell.eiendeGruppeId = avstemning.eiendeGruppeId;
        modell.spesifikasjon = {
            tittel: avstemning.tittel,
            beskrivelse: avstemning.beskrivelse,
            alternativer: _(avstemning.avstemningsalternativer).map(alternativ => ({id: alternativ.id, tittel: alternativ.tittel})).value()
        };
        modell.leggTilNyttAlternativ(); //viser alltid en tom rad til slutt
        return modell;
    }

    tittelEndret(alternativ: l.AvstemningsalternativSpesifikasjon) {
        if (_.isEmpty(_.last(this.spesifikasjon.alternativer).tittel)) return;
        this.leggTilNyttAlternativ();
    }

    erIkkeSisteTommeRad(alternativ: l.AvstemningsalternativSpesifikasjon) {
        const sisterad = _.last(this.spesifikasjon.alternativer);
        return !(_.isEmpty(sisterad.tittel) && alternativ === sisterad);
    }

    slett(alternativ: l.AvstemningsalternativSpesifikasjon) {
        _.pull(this.spesifikasjon.alternativer, alternativ);
    }

    leggTilNyttAlternativ(){
        this.spesifikasjon.alternativer.push({id:null, tittel:''});
    }

    harMinstEttIkkeTomtAlternativ() {
        return this.ikkeBlankeAlternativer().length > 0;
    }

    somOpprettAvstemningSpesifikasjon(): l.OpprettAvstemningSpesifikasjon {
        return {
            id: this.avstemningId,
            sakId: this.sakId,
            tittel: this.spesifikasjon.tittel,
            beskrivelse: this.spesifikasjon.beskrivelse,
            alternativer: this.ikkeBlankeAlternativer()
        };
    }

    somOppdaterAvstemningSpesifikasjon(): l.OppdaterAvstemningSpesifikasjon {
        return {
            id: this.avstemningId,
            tittel: this.spesifikasjon.tittel,
            beskrivelse: this.spesifikasjon.beskrivelse,
            alternativer: this.ikkeBlankeAlternativer()
        };
    }

    private ikkeBlankeAlternativer(): l.AvstemningsalternativSpesifikasjon[] {
        return _(this.spesifikasjon.alternativer).filter(alternativ => !_.isEmpty(alternativ.tittel)).value();
    }

}
